export const validateOrderTemplateName = (name: string, existingNames: string[]): boolean => {
  return !!name.trim() && !existingNames.includes(name);
};
